import translating from './translate.json';

const fields = (subCategoriesData, isCreate) => {
  return [
    {
      name: 'Gene',
      label: translating.name,
      required: true,
      readOnly: isCreate ? false : true
    },
    {
      name: 'rsNo',
      label: 'rsNo',
      required: true,
      width: '100px',
      readOnly: isCreate ? false : true
    },
    {
      name: 'eGenderLab',
      label: translating.gender,
      type: 'select',
      default: 'לא רלוונטיות מגדרית',
      options: [
        { id: 'לא רלוונטיות מגדרית', name: 'לא רלוונטיות מגדרית' },
        { id: 'גבר', name: 'גבר' }
      ],
      required: true
    },
    {
      name: 'genotip',
      label: 'genotip',
      required: true,
      width: '100px',
      readOnly: isCreate ? false : true
    },
    {
      name: 'geneWeight',
      label: translating.weight,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'geneSubCategoryId',
      label: translating.category,
      subField: 'name',
      default: '1',
      fromOptions: 'geneSubCategory',
      required: true,
      type: 'select',
      options: subCategoriesData
    },
    {
      name: 'reportTextId',
      label: translating.txt,
      required: true,
      readOnly: isCreate ? false : true
    }
  ];
};

export default fields;
